import React, { useState } from "react";
import badge from "../../../assets/badge.svg";
import QalortButton from "../../Button";
import confetti from "../../../assets/confetti.svg";
import close from "../../../assets/close-cohort.svg";
import check from "../../../assets/check.gif";
import CohortDetailsPreview from "../CohortDetailsPreview";
import { useNavigate } from "react-router-dom";
import ShareUrl from "../../ShareUrl";

function SuccessCohort({ successOpen, setSuccessModal, newCohort }) {
  const [shareCohort, setShareCohort] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div
        className={`bg-pri-tint-3 w-full flex justify-center items-center h-screen ${
          successOpen ? "flex" : "hidden"
        }`}
      >
        <div className="bg-white w-[547px] rounded-lg pb-7 border border-grey-2 shadow-[0_4px_30px_0_#0606110F]">
          <div className="w-full relative">
            <img
              src={close}
              className="absolute right-2 top-4 cursor-pointer"
              onClick={() => navigate("/cohort")}
            />
            <img src={confetti} alt="" />
            <div className="flex w-full justify-center items-center -mt-[120px]">
              <img src={check} alt="" className="w-[120px]" />
            </div>
          </div>
          <div className="px-7">
            <div className="text-center">
              <h6 className="font-semibold mb-0 text-dark">
                Cohort created successfully!
              </h6>
              <p className="text-tint p-xs mb-0 font-medium">
                You can now explore and manage your cohort!
              </p>
            </div>

            <div className="bg-light-tint px-[38px] py-8 mt-[38px]">
              <p className="p-sm font-semibold text-main mb-0">
                Ready to start mentoring?
              </p>
              <p className="p-sm font-semibold text-tint mb-0">
                Here are a few tips to get started.
              </p>

              <div className="flex flex-col gap-1.5 mt-[18px] mb-[44px]">
                <p className="flex gap-2.5 items-center p-xs font-medium text-tint mb-0">
                  <span>
                    <img src={badge} alt="" />
                  </span>
                  Post a welcome message or introductory activity.
                </p>
                <p className="flex gap-2.5 items-center p-xs font-medium text-tint mb-0">
                  <span>
                    <img src={badge} alt="" />
                  </span>
                  Share guidelines and goals for the Cohort.
                </p>
                <p className="flex gap-2.5 items-center p-xs font-medium text-tint mb-0">
                  <span>
                    <img src={badge} alt="" />
                  </span>
                  Encourage questions and interactions.
                </p>
              </div>

              <div className="flex flex-col gap-2.5">
                <QalortButton
                  type="primary"
                  className="py-3 px-9 w-full"
                  onClick={() => navigate(`/ct/${newCohort?.slug}`)}
                >
                  View Cohort
                </QalortButton>
                <QalortButton
                  className="border border-pri bg-pri-tint-3 pri py-3 px-9 w-full"
                  onClick={() => {
                    setSuccessModal(false);
                    setShareCohort(true);
                  }}
                >
                  Share cohort
                </QalortButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <CohortDetailsPreview
        isOpen={cohortDetails}
        onClose={() => {
          setCohortDetails(false);
          navigate("/cohort");
        }}
        cohortDetails={newCohort?.slug}
        outsideDashboard={false}
      /> */}
      <ShareUrl
        title="Cohort"
        visible={shareCohort}
        onCancel={() => setShareCohort(false)}
        setShareModalVisible={setShareCohort}
        url={`${window?.location.origin}/ct/${newCohort?.slug}`}
        cohortName={newCohort?.title}
      />
    </>
  );
}

export default SuccessCohort;
